// Footer.js
import React from 'react';

const Footer = () => (
  <footer className="bg-[#2D2D2D] text-white py-6 px-4 sm:px-6 lg:px-8">
    <div className="flex flex-col md:flex-row justify-between items-center max-w-7xl mx-auto text-xs sm:text-sm font-roboto space-y-4 md:space-y-0">
      <div className="text-center md:text-left max-w-sm md:max-w-none">
        <span>Office Address:</span>
        <span className="block md:inline md:ml-2">Awfis, 5th Floor, Raheja Titanium, Goregaon East, Mumbai - 400063</span>
      </div>
      <div className="flex flex-col sm:flex-row items-center gap-4 md:gap-8">
        <div>
          <span>Contact Us: </span>
          <a href="mailto:contact@novecta.co.in" className="hover:underline">contact@novecta.co.in</a>
        </div>
        <div>© Novecta Solutions LLP</div>
      </div>
    </div>
  </footer>
);

export default Footer;